import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-menu",
  "use": "svg-icon-menu-usage",
  "viewBox": "0 0 4 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 13\" id=\"svg-icon-menu\"><path clip-rule=\"evenodd\" d=\"m.5 1.5c0 .82843.67157 1.5 1.5 1.5s1.5-.67157 1.5-1.5c0-.828427-.67157-1.5-1.5-1.5s-1.5.671573-1.5 1.5zm1.5 6.5c-.82843 0-1.5-.67157-1.5-1.5s.67157-1.5 1.5-1.5 1.5.67157 1.5 1.5-.67157 1.5-1.5 1.5zm0 5c-.82843 0-1.5-.6716-1.5-1.5s.67157-1.5 1.5-1.5 1.5.6716 1.5 1.5-.67157 1.5-1.5 1.5z\" fill=\"#fff\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol